import * as React from "react";
import { withNamespaces, WithNamespaces } from "react-i18next";
import { Link } from "react-router-dom";
import { Contact } from "src/redux/user";
import { Project, Prestation } from "src/redux/projects";

interface Props {
  currentLocation: string;
  contact: Contact;
  projects: Project[];
  project: Project | undefined;
  prestation: Prestation | undefined;
}
type PropsWithNamespaces = Props & WithNamespaces;
class Sidebar extends React.Component<PropsWithNamespaces> {
  render() {
    return (
      <div
        className={`sidebar ${
          this.props.currentLocation.indexOf("proposal") > 0
            ? "sidebar-proposal"
            : ""
        }`}
      >
        <div className="sidebar-infos">
          <div className="d-flex align-items-center h-100">
            <img src="assets/logo-cogedim.svg" alt="logo" />
          </div>
        </div>
        <div className="sidebar-nav">
          <Link
            to="/projects"
            className={
              this.props.currentLocation.startsWith(`/projects`)
                ? "current"
                : ""
            }
          >
            <div className="d-flex flex-column flex-1">
              <p>{this.props.t(`sidebar.menu.projects.title`)}</p>
              <small>{this.props.t(`sidebar.menu.projects.label`)}</small>
            </div>
            <img src="assets/svgs/right-chevron.svg" width="10px" />
          </Link>
          <Link
            to="/library"
            className={
              this.props.currentLocation.startsWith(`/library`) ? "current" : ""
            }
          >
            <div className="d-flex flex-column flex-1">
              <p>{this.props.t(`sidebar.menu.library.title`)}</p>
              <small>{this.props.t(`sidebar.menu.library.label`)}</small>
            </div>
            <img src="assets/svgs/right-chevron.svg" width="10px" />
          </Link>
        </div>
        <div className="sidebar-user">
          <div className="sidebar-user-picture d-none d-lg-flex ">
            <img className="d-lg-flex " src={this.props.contact.avatar} />
          </div>
          <div className="sidebar-user-infos">
            <p className="mb-1">{this.props.t(`sidebar.contact.title`)}</p>
            <p className="mb-0 font-weight-bold">
              {this.props.contact.firstname}&nbsp;
              {this.props.contact.lastname}
            </p>
            <p className="mb-2 font-weight-bold">{this.props.contact.phone}</p>
            <a href={`mailto:${this.props.contact.email}`}>
              <img src="assets/svgs/email.svg" />
              <span>{this.props.t(`sidebar.contact.mailLink`)}</span>
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default withNamespaces()(Sidebar);



// WEBPACK FOOTER //
// ./src/components/Sidebar.tsx